import axios from 'axios'
import { CATALOGO_ENDPOINT } from '../../endpoints'

export async function syncSalesChannel(catalog_id) {
  const url = `${CATALOGO_ENDPOINT}/syncSalesChannel/${catalog_id}`
  return axios.put(url)
}
